import _firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};



export const firebase = _firebase;;
export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth;
export const firestore = firebase.firestore();
export const functions = firebase.app().functions('europe-west3');

// export function fixTimeStamps(doc: any) {
//   const _doc = { ...doc };
//   for (const key in _doc) {
//     if (_doc[ key ] instanceof _firebase.firestore.Timestamp) {
//       _doc[ key ] = (_doc[ key ] as _firebase.firestore.Timestamp).seconds * 1000;
//     }
//   }
//   return _doc;
// }

export function parseDoc<T>(snapshot: _firebase.firestore.DocumentSnapshot) {
  let doc: any = snapshot.data();
  doc.id = snapshot.id;
  // doc = fixTimeStamps(doc);
  return doc as T;
}


export interface LiveQueryArgs<T> {
  query: _firebase.firestore.Query;
  onAdd: (item: T) => void;
  onUpdate: (item: T) => void;
  onDelete: (item: T) => void;
  onInitial?: (items: T[], cursor?: _firebase.firestore.DocumentSnapshot) => void;
  onError?: (err: Error) => void;
  skipInitialOnAdd?: boolean;
}

export function firestoreLiveQuery<ItemType>(args: LiveQueryArgs<ItemType>) {
  let initial = true;
  try {
    return args.query.onSnapshot({
      next: (snapshot) => {
        const initialList: ItemType[] = [];

        let cursor: any;

        snapshot.docChanges().forEach(doc => {
          const item = parseDoc<ItemType>(doc.doc);
          if (doc.type === 'added') {
            initialList.push(item);
            if (!initial || !args.skipInitialOnAdd) {
              args.onAdd(item);
            }
          }
          else if (doc.type === 'modified') {
            args.onUpdate(item);
          }
          else if (doc.type === 'removed') {
            args.onDelete(item);
          }
          cursor = doc.doc;
        })
        if (initial) {
          args.onInitial && args.onInitial(initialList, cursor);
          initial = false;
        }
      },
      error: (err) => {
        console.error(err);
        args.onError && args.onError(err);
      }
    })
  }
  catch (e) {
    console.error(e);
    return false;
  }
}


export interface LiveDocArgs<T> {
  ref: _firebase.firestore.DocumentReference,
  onUpdate: (item: T) => void;
  onGet: (item: T) => void;
  onError?: (e: Error) => void;
}

export function firestoreLiveDoc<ItemType>(args: LiveDocArgs<ItemType>) {
  let initial = true;
  try {
    return args.ref.onSnapshot({
      next: (snapshot) => {
        const doc = parseDoc<ItemType>(snapshot);
        if (initial) {
          args.onGet(doc);
          initial = true;
        }
        else {
          args.onUpdate(doc);
        }
      },
      error: (err) => {
        args.onError && args.onError(err);
      }
    })
  }
  catch (e) {
    console.error(e);
    return false;
  }
}

export async function firestoreQuery<ItemType>(query: _firebase.firestore.Query) {
  try {
    const result = await query.get();
    return {
      list: result.docs.map(doc => parseDoc<ItemType>(doc)),
      lastItem: result.docs.length > 0 ? result.docs[result.docs.length - 1] : null,
    };
  }
  catch (e) {
    console.error(e);
    return {
      list: [],
      lastItem: null as any,
    };
  }
}